export function categories(state){
    return state.categories
}

export function category(state){
    return state.category
}

export function search(state){
    return state.search
}